import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/effect';
import 'bootstrap';
import Waves from "node-waves";
import { throttle } from 'throttle-debounce';
import { debounce } from 'throttle-debounce';





$.throttle = throttle;
$.debounce = debounce;

global.jQuery = $;
global.$ = $;
window.$ = window.jQuery = $;


//import '../libs/w2ui/w2ui-2.min.js';